module.exports = __webpack_public_path__ + "img/app-store-logo-fr.7a687de4.png";